"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationPushDataSchema = exports.VisitEngineerNotificationPushDataSchema = exports.VISIT_ENGINEER_NOTIFICATION_ACTIONS = exports.CustomerProfileNotificationPushDataSchema = exports.CustomerActionNotificationPushDataSchema = exports.ExmCallNotificationPushDataSchema = exports.CrmCallbackNotificationPushDataSchema = exports.WhatsAppNotificationPushDataSchema = exports.LeadNotificationPushDataSchema = exports.LeadSmsNotificationPreferencesSchema = exports.LeadNotificationPreferencesSchema = exports.LEAD_NOTIFICATION_STAGES = exports.LEAD_NOTIFICATION_DEFAULT_STAGE_KEYS = void 0;
exports.isLeadNotificationStageKey = isLeadNotificationStageKey;
exports.createDefaultLeadNotificationPreferences = createDefaultLeadNotificationPreferences;
exports.createDefaultLeadSmsNotificationPreferences = createDefaultLeadSmsNotificationPreferences;
exports.getLeadNotificationStage = getLeadNotificationStage;
const zod_1 = require("zod");
exports.LEAD_NOTIFICATION_DEFAULT_STAGE_KEYS = [
    'new_lead',
    'inspection_scheduled',
];
const stageAliases = new Map([
    ['scheduled_inspection', 'inspection_scheduled'],
]);
const stagesByKey = new Map([
    ['new_lead', { key: 'new_lead', label: 'ליד חדש' }],
    ['inspection_scheduled', { key: 'inspection_scheduled', label: 'קביעת בדיקה' }],
]);
exports.LEAD_NOTIFICATION_STAGES = Array.from(stagesByKey.values());
function isLeadNotificationStageKey(value) {
    return stagesByKey.has(stageAliases.get(value) ?? value);
}
const LeadNotificationStageKeySchema = zod_1.z.string().min(1).refine(isLeadNotificationStageKey);
exports.LeadNotificationPreferencesSchema = zod_1.z
    .object({
    schemaVersion: zod_1.z.literal(1),
    enabled: zod_1.z.boolean(),
    destinationStageKeys: zod_1.z.array(LeadNotificationStageKeySchema),
    excludeOwnActions: zod_1.z.boolean(),
})
    .strict();
function createDefaultLeadNotificationPreferences() {
    return {
        schemaVersion: 1,
        enabled: true,
        destinationStageKeys: [...exports.LEAD_NOTIFICATION_DEFAULT_STAGE_KEYS],
        excludeOwnActions: true,
    };
}
exports.LeadSmsNotificationPreferencesSchema = zod_1.z
    .object({
    schemaVersion: zod_1.z.literal(1),
    enabled: zod_1.z.boolean(),
    phone: zod_1.z.string().regex(/^\+9725\d{8}$/).nullable(),
    destinationStageKeys: zod_1.z.array(LeadNotificationStageKeySchema),
    excludeOwnActions: zod_1.z.boolean(),
})
    .strict()
    .superRefine((preferences, context) => {
    if (!preferences.enabled || preferences.phone)
        return;
    context.addIssue({
        code: zod_1.z.ZodIssueCode.custom,
        path: ['phone'],
        message: 'A valid Israeli mobile number is required when SMS notifications are enabled',
    });
});
function createDefaultLeadSmsNotificationPreferences() {
    return {
        schemaVersion: 1,
        enabled: false,
        phone: null,
        destinationStageKeys: [...exports.LEAD_NOTIFICATION_DEFAULT_STAGE_KEYS],
        excludeOwnActions: true,
    };
}
exports.LeadNotificationPushDataSchema = zod_1.z
    .object({
    type: zod_1.z.literal('lead_stage_entered'),
    eventId: zod_1.z.string().min(1),
    companyId: zod_1.z.string().min(1),
    dealId: zod_1.z.string().min(1),
    destinationStageKey: LeadNotificationStageKeySchema,
    url: zod_1.z.string().min(1),
})
    .strict()
    .superRefine((payload, context) => {
    if (payload.url !== `/crm/${payload.dealId}`) {
        context.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            path: ['url'],
            message: 'Notification URL must target its deal',
        });
    }
});
// Installed apps parse this payload strictly, so every field added here stops notification taps
// from navigating on all older builds until they are replaced. Keep the shape frozen and free of
// customer contact data; carry anything new in Firestore behind the dealId/conversationId instead.
exports.WhatsAppNotificationPushDataSchema = zod_1.z
    .object({
    type: zod_1.z.literal('whatsapp_inbound'),
    eventId: zod_1.z.string().min(1),
    companyId: zod_1.z.string().min(1),
    dealId: zod_1.z.string().min(1),
    conversationId: zod_1.z.string().min(1),
    url: zod_1.z.string().min(1),
})
    .strict()
    .superRefine((payload, context) => {
    if (payload.url !== `/crm/${payload.dealId}`) {
        context.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            path: ['url'],
            message: 'Notification URL must target its deal',
        });
    }
});
exports.CrmCallbackNotificationPushDataSchema = zod_1.z
    .object({
    type: zod_1.z.literal('crm_callback_due'),
    eventId: zod_1.z.string().min(1),
    companyId: zod_1.z.string().min(1),
    dealId: zod_1.z.string().min(1),
    url: zod_1.z.string().min(1),
})
    .strict()
    .superRefine((payload, context) => {
    if (payload.url !== `/crm/${payload.dealId}`) {
        context.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            path: ['url'],
            message: 'Notification URL must target its deal',
        });
    }
});
exports.ExmCallNotificationPushDataSchema = zod_1.z.object({
    type: zod_1.z.literal('exm_call_captured'),
    eventId: zod_1.z.string().min(1),
    companyId: zod_1.z.string().min(1),
    dealId: zod_1.z.string().min(1),
    url: zod_1.z.string().min(1),
}).strict().superRefine((payload, context) => {
    if (payload.url !== `/crm/${payload.dealId}`) {
        context.addIssue({ code: zod_1.z.ZodIssueCode.custom, path: ['url'], message: 'Notification URL must target its deal' });
    }
});
exports.CustomerActionNotificationPushDataSchema = zod_1.z.object({
    type: zod_1.z.literal('customer_activity'),
    action: zod_1.z.enum(['message_read', 'visit_confirmed']),
    eventId: zod_1.z.string().min(1),
    companyId: zod_1.z.string().min(1),
    dealId: zod_1.z.string().min(1),
    url: zod_1.z.string().min(1),
}).strict().superRefine((payload, context) => {
    if (payload.url !== `/crm/${payload.dealId}`) {
        context.addIssue({ code: zod_1.z.ZodIssueCode.custom, path: ['url'], message: 'Notification URL must target its deal' });
    }
});
exports.CustomerProfileNotificationPushDataSchema = zod_1.z.object({
    type: zod_1.z.literal('customer_profile_updated'),
    eventId: zod_1.z.string().min(1),
    companyId: zod_1.z.string().min(1),
    dealId: zod_1.z.string().min(1),
    url: zod_1.z.string().min(1),
}).strict().superRefine((payload, context) => {
    if (payload.url !== `/crm/${payload.dealId}`) {
        context.addIssue({ code: zod_1.z.ZodIssueCode.custom, path: ['url'], message: 'Notification URL must target its deal' });
    }
});
exports.VISIT_ENGINEER_NOTIFICATION_ACTIONS = [
    'cancelled',
    'postponed',
    'removed',
    'details_updated',
];
exports.VisitEngineerNotificationPushDataSchema = zod_1.z.object({
    type: zod_1.z.literal('visit_engineer_update'),
    action: zod_1.z.enum(exports.VISIT_ENGINEER_NOTIFICATION_ACTIONS),
    eventId: zod_1.z.string().min(1),
    companyId: zod_1.z.string().min(1),
    visitId: zod_1.z.string().min(1),
    url: zod_1.z.string().min(1),
}).strict().superRefine((payload, context) => {
    const calendarUrl = /^\/calendar(?:\?date=\d{4}-\d{2}-\d{2})?$/;
    const expected = payload.action === 'removed'
        ? calendarUrl.test(payload.url)
        : payload.url === `/schedule/${payload.visitId}`;
    if (!expected) {
        context.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            path: ['url'],
            message: payload.action === 'removed'
                ? 'Removed-visit notification URL must target the calendar'
                : 'Notification URL must target its visit',
        });
    }
});
exports.NotificationPushDataSchema = zod_1.z.union([
    exports.LeadNotificationPushDataSchema,
    exports.WhatsAppNotificationPushDataSchema,
    exports.CrmCallbackNotificationPushDataSchema,
    exports.ExmCallNotificationPushDataSchema,
    exports.CustomerProfileNotificationPushDataSchema,
    exports.CustomerActionNotificationPushDataSchema,
    exports.VisitEngineerNotificationPushDataSchema,
]);
function getLeadNotificationStage(stage) {
    const rawKey = stage.subStageId ?? stage.mainStageId;
    const key = stageAliases.get(rawKey) ?? rawKey;
    return stagesByKey.get(key) ?? null;
}
